import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { ErrorAlert } from 'smartsuite-ui';
import BagSummaryHeader from './components/BagSummaryHeader';
import { decorateNodes } from './utils/nodeUtilities';
import TimeLineAndDetails from './components/TimeLineAndDetails';
import BagSummaryHeaderSkeleton from '../skeletonComponents/BagSummaryHeaderSkeleton';
import TimeLineAndDetailsSkeleton from '../skeletonComponents/TimeLineAndDetailsSkeleton';
import useSkeletonContext from '../skeletonComponents/useSkeletonContext';

export default function Content(props) {
    const { id } = useParams();
    const { showSkeleton } = useSkeletonContext();

    if (showSkeleton) {
        return (
            <div className="bag-summary-content">
                <BagSummaryHeaderSkeleton />
                <TimeLineAndDetailsSkeleton />
            </div>
        );
    }

    if (!id) {
        return null;
    }

    const bagResult = props.bags?.find((x) => x.bagSelectorResult.id === id);
    if (!bagResult) {
        return (
            <div className="bag-summary-content">
                <ErrorAlert>{`Unable to find bag`}</ErrorAlert>
            </div>
        );
    }

    const bagTimeLine = decorateNodes(bagResult.bagTimelineNodes);
    const isBagDeleted =
        bagResult.bagSelectorResult.flightItinerary.length == 0;

    return (
        <div className="bag-summary-content">
            <BagSummaryHeader
                bagSelectorResult={bagResult.bagSelectorResult}
                bagDetailsLink={props.urlData.bagDetailsUri}
                tracerDetailsLink={props.urlData.tracerRecordDetailsUri}
            />
            <TimeLineAndDetails
                bagTimeLine={bagTimeLine}
                isBagDeleted={isBagDeleted}
                urlData={props.urlData}
                key={id}
                id={id}
            ></TimeLineAndDetails>
        </div>
    );
}

Content.propTypes = {
    bags: PropTypes.instanceOf(Array),
    urlData: PropTypes.instanceOf(Object),
};
